<template>
    <div class="d-content">
        <!-- Myteam View -->
         <dashboard-content-nav :nav="navItems"/>
        <keep-alive>
            <component :is="currentComponent" :entity_index="entity_index"></component>
        </keep-alive>
    </div>
</template>


<script>
import dashboardContentNav from "@/components/dashboard/contentNav.vue";

//Pages 
// import reportees from "./reportees.vue";
// import approval from "./approval.vue";
import payslip from "./payslip.vue";
import compensation from "./compensation.vue";
import itStatement from "./itStatement.vue";
import npsDeclaration from "./npsDeclaration.vue";
import vpfDeclaration from "./vpfDeclaration.vue";

import itDeclaration from "./itDeclaration.vue";
import itProofSubmission from "./itProofSubmission.vue";
import itDeclarationDashboard from "./itDeclarationDashboard.vue";
import payrollReports from "./payrollReports.vue";
//import compensationMain from "./compensationMain.vue";

// this.$router.query
// in query pass the key, paygroup, costcenter
// if 
// currentcomponent(){
  // if costcenter
 // return ()=>import('./coscenter.vue') 
 // elnse if designatio
//
// }
const mapNameToComponents = {
//   "reportees": reportees,
//   "approval" :approval,
  // "payslip" :payslip,
  // "itStatement": itStatement,
  //"compensationMain": compensationMain,
  "npsDeclaration": npsDeclaration,
  "vpfDeclaration": vpfDeclaration,
  "itDeclaration": itDeclaration,
  "itProofSubmission": itProofSubmission,
  "itDeclarationDashboard" : itDeclarationDashboard,
  // "compensation": compensation,
  "payrollReports": payrollReports
}

const getPathForStep = (entity_index,step_name, sub_step) => {
  if (sub_step) 
    return `/dashboard/${entity_index}/mysalary/${step_name}/${sub_step}`
  else
    return `/dashboard/${entity_index}/mysalary/${step_name}`
}


const nav_items = (entity_index) =>([
      {
        type: "navitem",
        label: "Payroll Reports",
        path: getPathForStep(entity_index,'payrollReports'),
      },
      // {
      //   type: "navitem",
      //   label: "Compensation", 
      //   path: getPathForStep(entity_index,'compensation'),
      // },
      // {
      //   type: "navitem",
      //   label: "IT Statement", 
      //   path: getPathForStep(entity_index,'itStatement'),
      // },
      {
        type: "navitem",
        label: "VPF Declaration", 
        path: getPathForStep(entity_index,'vpfDeclaration'),
      },
      {
        type: "navitem",
        label: "NPS Declaration", 
        path: getPathForStep(entity_index,'npsDeclaration'),
      },
      // {
      //   type: "navitem",
      //   label: "IT Declaration", 
      //   path: getPathForStep(entity_index, 'itDeclaration'),
      // },
      // {
      //   type: "navitem",
      //   label: "IT Proof Submission", 
      //   path: getPathForStep(entity_index,'itProofSubmission'),
      // },
      // {
      //   type: "navitem",
      //   label: "IT Simulator", 
      //   path: getPathForStep(entity_index,'itDeclarationDashboard'),
      // },
    //   {
    //     type: "navitem",
    //     label: "Utilities",
    //     path: getPathForStep(entity_index,'utilities'),
    //     icon : "reports"
    //   }
]);
export default {
   components : {
      dashboardContentNav
  },
  props: ['sub_step','entity_index'],
  data(){
    return{
         navItems : [],
         isSubmitted: null,
    }
  },
   methods:{
    contentShow(event)
    {
      var sections = document.querySelectorAll('.d-payroll__accordBlock');
      for (let i = 0; i < sections.length; i++){
          sections[i].classList.remove('active');
      }
      event.target.parentNode.classList.toggle("active");
    },
  },
  created(){
      this.navItems = nav_items(this.entity_index);
      this.navItems = this.le_id == '6c786ee5-679d-4a3f-bd66-fc502c9f051a' ? this.navItems : [this.navItems[0]];
      this.isSubmitted = sessionStorage.getItem('isDeclared');
      // if(this.isSubmitted == 'false'){
      //   this.navItems[this.navItems.length -1].path = `/dashboard/${this.entity_index}/mysalary/itDeclarationDashboard`;
      // }
  },
  computed:{
    currentComponent: function() {
        return mapNameToComponents[this.sub_step];
    },
    le_id() {
      return localStorage.getItem("le_id")
    },
  }
}
</script>
<style>

</style>
